import { render, staticRenderFns } from "./KategoriSOS.vue?vue&type=template&id=2a071cdd&scoped=true"
import script from "./KategoriSOS.vue?vue&type=script&lang=js"
export * from "./KategoriSOS.vue?vue&type=script&lang=js"
import style0 from "./KategoriSOS.vue?vue&type=style&index=0&id=2a071cdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a071cdd",
  null
  
)

export default component.exports